// extracted by mini-css-extract-plugin
module.exports = {"tabs":"FamilyGroupTabs_tabs__33mcj","tab":"FamilyGroupTabs_tab__2qvy-","active":"FamilyGroupTabs_active__3yS5X"};